<template>
  <router-link :to="getLink(feature)" class="feature-card">
    <div
      :style="{ background: feature.lighter, color: feature.darker }"
      class="feature-icon"
    >
      <i :class="feature.icon" aria-hidden="true" />
    </div>
    <h3 class="feature-title">{{ feature.title }}</h3>
    <p class="text-muted feature-description">{{ feature.description }}</p>
    <a v-if="enableLinking" class="learn-more">Learn More</a>
    <a v-else class="learn-more">Coming soon</a>
  </router-link>
</template>

<script>
export default {
  methods: {
    getLink(feature) {
      if (!this.enableLinking) {
        return "";
      } else {
        return `/features/${feature.alias}`;
      }
    }
  },

  props: {
    feature: {
      type: Object,
      required: true
    },
    enableLinking: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
.feature-card {
  width: 360px;
  height: 100%;
  margin: 20px 20px;
  padding: 60px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  text-decoration: none;

  // center everything in card
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  touch-action: pan-y;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  transition: all 0.25s ease-out;

  &:hover {
    box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-10px);
  }

  &.focused {
    margin: -60px 35px 0 35px;
  }

  .feature-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    font-size: 21px;
    font-weight: 600;
    width: 65px !important;
    height: 65px !important;
    transition: all 0.25s ease-out;

    box-shadow: 0 2px 3px rgba(50, 50, 93, 0.11), 0 1px 9px rgba(0, 0, 0, 0.08);
  }

  .feature-title {
    font-size: 27px;
    margin: 30px 0 10px;
    font-weight: 600;
    color: black;
  }

  .feature-description {
    font-weight: 500;
    line-height: 28px;
    // margin: 0 0 50px;
  }

  .learn-more {
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 1px;
    font-weight: 600;
    color: #2780e3;
    margin-top: auto; // align to bottom of card
  }
}
</style>
